<form class="tt-anchor-link-edit_form" [formGroup]="editLinkForm">
  <tt-form-field>
    <label for="anchor-link__title-input" ttLabel>{{ 'LinkTitle' | transloco }}:</label>
    <input
      data-testid="anchor-link_title-input"
      id="anchor-link__title-input"
      required
      ttInput
      type="text"
      [formControl]="editLinkForm.controls.title" />
    @if (editLinkForm.controls.title.invalid) {
      <tt-error>{{ 'Validation.FieldRequired' | transloco }}</tt-error>
    }
  </tt-form-field>

  <tt-form-field>
    <label for="anchor-link__description" ttLabel>{{ 'LinkDescription' | transloco }}:</label>
    <div class="tt-anchor-link-edit_form-description-wrapper">
      <common-rich-text-editor
        class="description"
        data-testid="anchor-link_description-input"
        id="anchor-link__description"
        [editorContent]="editLinkForm.controls.description.value ?? ' '"
        [toolbarType]="'reduced'"
        (editorContentChange)="updateDescription($event)" />
    </div>
  </tt-form-field>

  @if (!selectedInternalLink()) {
    <tt-form-field>
      <label for="anchor-link__link" ttLabel>{{ 'SearchOrPasteLink' | transloco }}:</label>
      <input
        #linkInputRef
        data-testid="anchor-link_target-search-input"
        id="anchor-link__link"
        required
        ttInput
        [formControl]="editLinkForm.controls.toUrl"
        (input)="handleToUrlChanged()" />
      <tt-error>{{ 'LinkNotSetError' | transloco }}</tt-error>
    </tt-form-field>
  } @else {
    <div class="tt-anchor-link-edit_selection">
      <div class="tt-anchor-link-edit_selection-left">
        @switch (selectedInternalLink().toElementType) {
          @case (LinkElementType.Chapter) {
            <mat-icon class="tt-anchor-link-edit_selection-icon" [icon]="'bookmark'" [iconSize]="16" />
          }
          @case (LinkElementType.Component) {
            <mat-icon class="tt-anchor-link-edit_selection-icon" [icon]="'component'" [iconSize]="16" />
          }
          @case (LinkElementType.FlowchartNode) {
            <mat-icon class="tt-anchor-link-edit_selection-icon" [icon]="'git-fork'" [iconSize]="16" />
          }
          @case (LinkElementType.External) {
            <mat-icon class="tt-anchor-link-edit_selection-icon" [icon]="'book'" [iconSize]="14" />
          }
        }

        <span class="tt-anchor-link-edit_selection-title">{{ originalTitle() }}</span>
      </div>

      <mat-icon class="tt-anchor-link-edit_selection-reset" [icon]="'x'" [iconSize]="16" (click)="removeInternalLink()" />
    </div>
  }

  <div class="tt-anchor-link-edit_actions">
    <button ttButton [variant]="'secondary'" (click)="cancelEdit.emit()"
      ><span>{{ 'Cancel' | transloco }}</span></button
    >
    <button data-testid="anchor-link_confirm-button"
      ttButton
      [disabled]="!selectedInternalLink() && !editLinkForm.valid"
      (click)="handleSaveButtonClicked()">
      {{ link().id ? ('Save' | transloco) : ('Add' | transloco) }}</button
    >
  </div>
</form>
